exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.highlight {\n  background-color: #EEEEEE;\n  padding: 12px;\n}\n.special {\n  font-weight: 600;\n}\n.text {\n  padding: 10px 0;\n}\n.buttons-section {\n  padding: 40px 0;\n}\n.next-btn, .data-btn, .back-btn, .select-btn {\n  background-color: #FFBD68;\n}\n.exit-btn {\n  background-color: #c7c7c7;\n}\nbutton {\n  width: 120px;\n  height: 40px;\n  margin-left: 10px;\n}\n\n\n", ""]);

// exports
